(function () {
  if (window.__veyrCommerceHeaderReady) return;
  window.__veyrCommerceHeaderReady = true;

  function updateCartCount(count) {
    var value = typeof count === 'number' ? count : parseInt(count, 10);
    if (isNaN(value)) return;

    document.querySelectorAll('[data-veyr-commerce-cart-count]').forEach(function (node) {
      node.textContent = String(value);
    });

    document.querySelectorAll('[data-veyr-commerce-cart]').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + value + (value === 1 ? ' item' : ' items'));
    });
  }

  document.addEventListener('cart:update', function (event) {
    var detail = event && event.detail;
    var resource = detail && detail.resource;
    if (resource && typeof resource.item_count !== 'undefined') {
      updateCartCount(resource.item_count);
      return;
    }
    if (detail && typeof detail.item_count !== 'undefined') {
      updateCartCount(detail.item_count);
    }
  });
})();
